import React from "react";
import Body from "./Body";

const Merchandise = () => {
  const _this = {};
  return <Body {..._this} />;
};

export default Merchandise;
